export const CURRENT_LANGUAGE = "currentLanguage";
export const USER_DATA_STORAGE_KEY = "userData";
export const USER_RIGHTS_STORAGE_KEY = "userRights";
export const USER_ALLOWED_ACTION_STORAGE_KEY = "userAllowedActions";
export const IS_AUTHENTICATED_KEY = "isAuth";
